import React, { useState } from 'react';
import { toast } from 'react-toastify';

// Styles
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

// Apis
import { deleteRaffleConfiguration } from 'js/library/utils/API/Draws/deleteRaffleConfiguration';

export const ModalDeleteDraw = ({ open, close, raffleIdentifier, reload }) => {
  const [loading, setLoading] = useState(false);

  const deleteDraw = async () => {
    setLoading(true);
    try {
      await deleteRaffleConfiguration(raffleIdentifier);
      toast.success('Sorteio deletado com sucesso!');
      reload((prev) => !prev);
      close();
    } catch (error) {
      toast.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={close}>
      <DialogTitle textAlign="center">Deletar</DialogTitle>
      <DialogContent
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          padding: '16px 24px',
        }}
      >
        <DialogContentText sx={{ paddingLeft: '0px', margin: '15px 0px' }}>
          Tem certeza que deseja deletar este sorteio?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={close} color="primary">
          Cancelar
        </Button>
        <Button onClick={() => deleteDraw()} color="secondary" autoFocus>
          {loading ? <CircularProgress size={25} thickness={5} /> : 'Continuar'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
